import Vue from 'vue'
import Router from 'vue-router'
import * as store2 from 'store'
import { STORE_USER_ID } from '@/global/util/constants'
import { tip } from '../util/util'

Vue.use(Router)

export const flattenMenu = data => {
  return data.reduce((acc, val) => {
    if (Array.isArray(val.children)) {
      return acc.concat(flattenMenu(val.children))
    }
    return acc.concat([val])
  }, [])
}

export const findMenu = (data, { fullPath, name } = {}) => {
  return data.find(menu => {
    if (fullPath.indexOf(menu.path) > -1) return true
    if (Array.isArray(menu.includePaths)) {
      return menu.includePaths.filter(v => v.includes(name)).length > 0
    }

    return false
  })
}

export const generateMenu = (routeData, prefixIndex) => {
  const menus = []

  routeData.forEach((route, index) => {
    const menu = {}
    menu.title = route.title

    if (route.icon) {
      menu.icon = route.icon
    }

    if (route.includePaths) {
      menu.includePaths = route.includePaths
    }

    if (route.children && route.children.length) {
      menu.children = generateMenu(route.children, index + 1)
    } else {
      menu.path = route.path
    }
    menu.index = prefixIndex ? prefixIndex + '-' + (index + 1) : `${index + 1}`
    menus.push(menu)
  })

  return menus
}

export const filterMenuByNames = (menuData, names) =>
  menuData
    .map(v => {
      if (names.find(name => name.indexOf(v.title) > -1)) {
        return v
      } else if (v.children) {
        const childMenus = filterMenuByNames(v.children, names)
        if (childMenus.length > 0) {
          v.children.splice(0, v.children.length, ...childMenus)
          return v
        }
      }
      return false
    })
    .filter(Boolean)

const getAccessPaths = menuData => {
  const path = []

  menuData.forEach(item => {
    const includePaths = item.includePaths || []
    path.push(...includePaths)

    if (item.path) {
      path.push(item.path)
    } else if (item.children) {
      path.push(...getAccessPaths(item.children))
    }
  })
  return path
}

const findAccessPath = menuData => menuData.find(item => (item.path ? item.path : findAccessPath(item.children)))

const addRoute = route => {
  const item = {}
  item.path = route.path
  item.name = route.name
  item.component = route.component

  if (route.meta) {
    item.meta = route.meta
  }
  return item
}

export const generateRoutes = (routeData, redirect = false) => {
  let routes = []

  if (redirect) {
    // routes.push({
    //   path: '',
    //   redirect: () => (routeData[0].path ? routeData[0].path : routeData[0].children[0].path)
    // })
  }

  routeData.forEach(route => {
    route.includePages &&
      route.includePages.forEach(page => {
        routes.push(addRoute(page))
      })

    if (route.children && route.children.length) {
      routes = routes.concat(generateRoutes(route.children))
    } else {
      routes.push(addRoute(route))
    }
  })

  return routes
}

export default function createRouter(options, store, platform) {
  const router = new Router({
    base: options.base,
    mode: 'history',
    routes: options.routes.slice(0, 1),
    scrollBehavior(to, from, savedPosition) {
      // 切换新路由，实现重载页面的效果
      if (savedPosition) {
        savedPosition = { x: 0, y: 0 }
        return savedPosition
      } else if (to.hash) {
        return { selector: to.hash }
      } else {
        return { x: 0, y: 0 }
      }
    }
  })

  router.beforeEach(async (to, from, next) => {
    if (!store.getters['login/menuData'].length && to.name !== 'login') {
      // 左侧菜单展示数据
      const menuData = generateMenu(options.routeData)
      const res = await store.dispatch('login/getMenu', { platform, menuData })
      if (res) {
        const { names, menus } = res
        const routes = generateRoutes(filterMenuByNames(options.routeData, names))
        routes.unshift({ path: '', redirect: (menus[0].path ? menus[0].path : menus[0].children[0].path) })
        options.routes[1].children = routes
        router.addRoutes(options.routes.slice(1))
        next({ ...to, replace: true })
      } else {
        next({ path: '/login' })
      }
    } else {
      if (to.name !== 'login') {
        const res = await store.dispatch('login/getStatus', { platform })
        if (res.code === 0 || (res.data && res.data.status !== 0)) {
          store2.remove(`${platform}:${STORE_USER_ID}`)
          const tipText = res.code === 0 ? '你还没有登录，请先登录' : '登录过期，请重新登录'
          return tip(tipText, { duration: 1000 }, () => {
            next({
              path: '/login',
              query: { redirect: to.fullPath }
            })
          })
        }

        if (from.name !== 'login') {
          const menuData = store.getters['login/menuData']
          const accessPaths = getAccessPaths(menuData)
          const currentAccessPath = accessPaths.find(path => to.path.indexOf(path) > -1)
          if (!currentAccessPath) {
            const firstAccessPath = findAccessPath(menuData)
            if (!menuData.length || !firstAccessPath) {
              return tip('你的账号对该系统无访问权限', { duration: 1000 }, () => {
                next({ path: '/login' })
              })
            } else {
              const firstMenu = findAccessPath(menuData)
              next({ path: firstMenu.path ? firstMenu.path : firstMenu.children[0].path })
            }

            /* return tip('访问权限不足', { duration: 1000 }, () => {
              next({ path: firstAccessPath.path ? firstAccessPath.path : firstAccessPath.children[0].path });
            }); */
          }
        }
      } else {
        const res = await store.dispatch('login/getStatus', { platform })
        if (res.data && res.data.status === 0) {
          next({ path: '/' })
        }
      }
      next()
    }
  })
  return router
}
